module.exports = __webpack_public_path__ + "assets/people/romaOsokin.f96ef86fb60ee59adbb43cdfb261f32a.png";